// extracted by mini-css-extract-plugin
export var chip = "_3v-0";
export var filterDropdown = "_3v-5";
export var filterItem = "_3v-6";
export var icon = "_3v-1";
export var removeButton = "_3v-3";
export var removeIcon = "_3v-4";
export var separator = "_3v-2";